/**
 * Color helpers for org-defined tag colors. Tag types store an optional
 * background color as hex #RRGGBB (enforced by the organisation service
 * schema); the text color is always derived, never stored.
 */

/** Matches the #RRGGBB format the backend schema enforces. */
export const isValidTagColor = (color: string): boolean => /^#[0-9a-fA-F]{6}$/.test(color);

/**
 * Pick black or white text for the given background — whichever contrasts
 * best per WCAG relative luminance. White wins below the canonical
 * ~0.179 luminance threshold (where the contrast ratios to black and
 * white are equal), which keeps white text on saturated mid-tones the
 * way Trello labels do.
 */
export function contrastTextColor(backgroundHex: string): "#000000" | "#ffffff" {
	if (!isValidTagColor(backgroundHex)) return "#000000";

	const [r, g, b] = [1, 3, 5].map((offset) => {
		const channel = parseInt(backgroundHex.slice(offset, offset + 2), 16) / 255;
		return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
	});

	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

	return luminance > 0.179 ? "#000000" : "#ffffff";
}
